var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"page","mode":"out-in"}},[_vm._t("default",[_c('router-view')])],2)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b2add96","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/Child.vue
// module id = WuYT
// module chunks = 66